import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getBrands() {
    return axios.post(ENV.carBaseUrl + "/brands/list", {}, this.requestConfig());
  }

  static getBrandGroups() {
    return axios.get(ENV.carBaseUrl + "/brands/groups/list", this.requestConfig());
  }
}

export default Service;
